import BoltIcon from "./BoltIcon.vue";
import ChatIcon from "./ChatIcon.vue";
import ClipboardIcon from "./ClipboardIcon.vue";
import GalleryFavoriteIcon from "./GalleryFavoriteIcon.vue";
import GenderBalanceIcon from "./GenderBalanceIcon.vue";
import HeartInHeartIcon from "./HeartInHeartIcon.vue";
import HeartShineIcon from "./HeartShineIcon.vue";
import MapPointRotateIcon from "./MapPointRotateIcon.vue";
import PartnerProfilesIcon from "./PartnerProfilesIcon.vue";
import ShieldCheckIcon from "./ShieldCheckIcon.vue";
import TuningIcon from "./TuningIcon.vue";

export default {
    BoltIcon,
    ChatIcon,
    ClipboardIcon,
    GalleryFavoriteIcon,
    GenderBalanceIcon,
    HeartInHeartIcon,
    HeartShineIcon,
    MapPointRotateIcon,
    PartnerProfilesIcon,
    ShieldCheckIcon,
    TuningIcon,
};
